import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

import AttendanceSyncLogs from "./routes/AttendanceLogs";
import AttendanceCategoryMapping from "./routes/AttendanceCategoryMapping";

export default store => ({
  path: "attendance",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "admin-schoolSetup-integrations" */ "./components"
        ),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;

        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [AttendanceSyncLogs(store), AttendanceCategoryMapping(store)],
});
